import React from "react";
import { Theme } from "./types/profile";
import { useUserTheme } from "src/shared/hooks/useUserTheme";

interface ProfileTabsProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
  theme: Theme | null;
}

const tabs = [
  { id: "profile", label: "My Profile", icon: "👤" },
  { id: "business", label: "Business Profile", icon: "💼" },
  { id: "theme", label: "Theme", icon: "🎨" },
  // { id: "configuration", label: "Page Configuration", icon: "⚙️" },
  // { id: "printerConfig", label: "Printer Config", icon: "🖨️" },
];

const ProfileTabs: React.FC<ProfileTabsProps> = ({ activeTab, onTabChange }) => {
  const { bgClass, fontClass } = useUserTheme();

  return (
    <div className="w-full bg-white p-1 rounded-xl border border-gray-200 shadow-2xs">
      <div className="grid grid-cols-3 gap-1.5 sm:gap-2">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.label;
          return (
            <button
              key={tab.id}
              type="button"
              className={`flex items-center justify-center space-x-2 px-3 py-2.5 rounded-lg transition-all duration-200 cursor-pointer text-xs sm:text-sm font-medium ${fontClass} ${
                isActive
                  ? `${bgClass} text-white font-semibold shadow-sm`
                  : "text-gray-600 hover:text-gray-900 hover:bg-gray-100/80 bg-transparent"
              }`}
              onClick={() => onTabChange(tab.label)}
            >
              <span className="text-base sm:text-lg shrink-0">{tab.icon}</span>
              <span className="truncate">{tab.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ProfileTabs;